export default __webpack_public_path__ + "assets/3576ef9d611d653f657d3b30bae72517.jpg";